<dx-popup
  class="home"
  #chatbotpopup
  [visible]="visible$ | async"
  title="COVID-19 Assessment"
  width="560"
  height="640" (onHidden)="navigateToParent(2)">
  <iframe #chatbotiframe class="response-iframe" frameborder="0"></iframe>  
</dx-popup>
